import { FORTA_BLUE } from '../../../../utils/colors';
import { FHChip } from '../../../base';
import {
  QUESTIONNAIRE_HISTORY_CHIP_FONT_SIZE,
  QUESTIONNAIRE_HISTORY_CHIP_WIDTH,
  QUESTIONNAIRE_HISTORY_STATUS_COLORS,
  QUESTIONNAIRE_HISTORY_STATUS_LABELS,
  QUESTIONNAIRE_HISTORY_TYPE,
  QUESTIONNAIRE_HISTORY_TYPE_COLORS,
} from '../constants';

import type { QuestionnaireStatus } from '../../../../store/questionnaires';

export const questionnaireHistoryColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'questionnaire_id',
    label: 'ID',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'type',
    label: 'Type',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value: string) => (
        <FHChip
          content={value}
          bgColor={
            value === QUESTIONNAIRE_HISTORY_TYPE.ONBOARDING ||
            value === QUESTIONNAIRE_HISTORY_TYPE.INTAKE
              ? QUESTIONNAIRE_HISTORY_TYPE_COLORS[value]
              : FORTA_BLUE.light1
          }
          fontSize={QUESTIONNAIRE_HISTORY_CHIP_FONT_SIZE}
          sx={{ width: QUESTIONNAIRE_HISTORY_CHIP_WIDTH, textAlign: 'center' }}
        />
      ),
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value: QuestionnaireStatus) => (
        <FHChip
          content={QUESTIONNAIRE_HISTORY_STATUS_LABELS[value]}
          bgColor={QUESTIONNAIRE_HISTORY_STATUS_COLORS[value]}
          fontSize={QUESTIONNAIRE_HISTORY_CHIP_FONT_SIZE}
          sx={{ width: QUESTIONNAIRE_HISTORY_CHIP_WIDTH, textAlign: 'center' }}
        />
      ),
    },
  },
  {
    name: 'client',
    label: 'Child name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'provider',
    label: 'Guardian name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'date_sent',
    label: 'Date sent',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'date_concluded',
    label: 'Date concluded',
    options: {
      filter: false,
      sort: true,
    },
  },
];
